export default "__VITE_ASSET__ed1fa033__"